/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

export default {
  calendar: {
    fromDate: new Date(new Date().setDate(new Date().getDate() - 1)),
    toDate: new Date(new Date().setDate(new Date().getDate() + 7)),
  },
};
